import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode:"hash",
  routes: [
    {path:"", redirect:"/firstopen"},   //重新定向到home组件
    {path:"/firstopen", component:()=>import("@/views/Home/firstopen")},
    {path:"/home", component:()=>import("@/views/Home/")},
    {path:"/home/notice", component:()=>import("@/views/Home/notice")},
    {path:"/home/notice/tk", component:()=>import("@/views/Home/notice/tk")},
    {path:"/home/makemoney", component:()=>import("@/views/Home/MakeMoney")},
    {path:"/home/makemoney/timer", component:()=>import("@/views/Home/MakeMoney/timer")},
    {path:"/home/newtask", component:()=>import("@/views/Home/NewTask")},
    {path:"/home/newtask/share", component:()=>import("@/views/Home/NewTask/Share")},
    {path:"/home/newtask/shareyqhd", component:()=>import("@/views/Home/NewTask/Shareyqhd")},
    {path:"/home/newtask/test", component:()=>import("@/views/Home/NewTask/test")},
    {path:"/home/newtask/out1", component:()=>import("@/views/Home/NewTask/out1")},
    {path:"/home/newtask/jxw", component:()=>import("@/views/Home/NewTask/jxw")},
    {path:"/home/newtask/xlx", component:()=>import("@/views/Home/NewTask/xlx")},
    {path:"/home/newtask/tm", component:()=>import("@/views/Home/NewTask/tm")},
    {path:"/home/newtask/hd", component:()=>import("@/views/Home/NewTask/hd")},
    {path:"/home/newtask/hdyq", component:()=>import("@/views/Home/NewTask/hdyq")},
    {path:"/home/newtask/hdyqinfo", component:()=>import("@/views/Home/NewTask/hdyqinfo")},
    {path:"/home/newtask/hdyqbm", component:()=>import("@/views/Home/NewTask/hdyqbm")},
    {path:"/home/newtask/hdyqyj", component:()=>import("@/views/Home/NewTask/hdyqyj")},
    {path:"/home/newtask/out2", component:()=>import("@/views/Home/NewTask/out2")},
    {path:"/home/outside/install", component:()=>import("@/views/Home/Outside/Install")},
    {path:"/home/outside/first", component:()=>import("@/views/Home/Outside/First")},
    {path:"/home/outside/rule", component:()=>import("@/views/Home/Outside/Rule")},
    {path:"/home/outside/dev", component:()=>import("@/views/Home/Outside/dev")},
    {path:"/home/outside/Taskhigh", component:()=>import("@/views/Home/Outside/Taskhigh")},
    {path:"/home/makemoney/task", component:()=>import("@/views/Home/MakeMoney/Task")},
    {path:"/home/makemoney/taskback", component:()=>import("@/views/Home/MakeMoney/Taskback")},
    {path:"/home/makemoney/taskhighback", component:()=>import("@/views/Home/MakeMoney/Taskhighback")},
    {path:"/home/makemoney/Taskhigh", component:()=>import("@/views/Home/MakeMoney/Taskhigh")},
    {path:"/home/apprentice", component:()=>import("@/views/Home/Apprentice")},
    {path:"/home/apprentice/apprenticeinfo", component:()=>import("@/views/Home/Apprentice/ApprenticeInfo"),
      children:[
        {path:"", redirect:"apprentices"},
        {path:"apprentices", component:()=>import("@/views/Home/Apprentice/apprentices")},
        {path:"disciples", component:()=>import("@/views/Home/Apprentice/disciples")},
      ]
    },
    {path:"/home/usercenter/high", component:()=>import("@/views/Home/UserCenter/high")},
    {path:"/home/usercenter", component:()=>import("@/views/Home/UserCenter")},
    {path:"/home/getmoney", component:()=>import("@/views/Home/UserCenter/GetMoney")},
    {path:"/home/getmoney/alipay", component:()=>import("@/views/Home/UserCenter/GetMoney/Alipay")},
    {path:"/home/getmoney/telephonecharge", component:()=>import("@/views/Home/UserCenter/GetMoney/TelephoneCharge")},
    {path:"/home/getmoney/wechat", component:()=>import("@/views/Home/UserCenter/GetMoney/WeChat")},
    {path:"/home/usercenter/bill", component:()=>import("@/views/Home/UserCenter/Bill"),
      children:[
        {path:"", redirect:"billdetails"},
        {path:"billdetails", component:()=>import("@/views/Home/UserCenter/Bill/billdetails")},
        {path:"drawmoney", component:()=>import("@/views/Home/UserCenter/Bill/drawMoney")},
      ]
    },
    {path:"/home/usercenter/help", component:()=>import("@/views/Home/UserCenter/Help")},
    {path:"/home/usercenter/tel", component:()=>import("@/views/Home/UserCenter/Tel")},
    {path:"/home/usercenter/cooperation", component:()=>import("@/views/Home/UserCenter/Cooperation")},
    {path:"/home/usercenter/about", component:()=>import("@/views/Home/UserCenter/About")},
    {path:"/home/usercenter/userinfo", component:()=>import("@/views/Home/UserCenter/Userinfo")},
    {path:"/home/usercenter/userinfo/alipay", component:()=>import("@/views/Home/UserCenter/Userinfo/Alipay")},
    {path:"/home/usercenter/userinfo/telephone", component:()=>import("@/views/Home/UserCenter/Userinfo/Telephone")},
    {path:"/home/install", component:()=>import("@/views/Home/Install")}
  ]
})

export default router;

